// extracted by mini-css-extract-plugin
module.exports = {"partnerActivityListItem":"YPbpM","partnerMaskWrapper":"OU84r","partnerActivityDescription":"Q6UtZ"};